// NATIVE

// INSTALLED

// CUSTOM
import { Grid, IconButton, Tooltip } from '@mui/material';
import InputField from '../../formFields/InputField';
import TextAreaField from '../../formFields/TextAreaField';
import AutocompleteField from '../../formFields/autocompleteField';
import { useSelector } from 'react-redux';
import InputNumeric from '../../formFields/InputNumeric';
import DatePickerField from '../../formFields/datePickerField';
import CheckboxField from '../../formFields/checkBoxField';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import { useEffect, useState } from 'react';
import { useFormikContext } from 'formik';
import DatePickerDefaultField from '../../formFields/datePickerDefaultField';

export const EditarExpressCheckin = (props: any) => {
  // USE FORMIK CONTEXT
  const formikProps: any = useFormikContext();

  // USE SELECTOR
  const { expressCheckin }: any = useSelector((state: any) => state.expressCheckin);

  const {
    formField: { e_code, e_adults, e_minors, e_arrival, e_departure, e_bussines },
  } = props;

  // USE STATE
  const [dataExpressCheckin, setDataExpressCheckin] = useState<any>(null);

  // USE EFFECT
  useEffect(() => {
    setDataExpressCheckin(expressCheckin);
  }, [expressCheckin]);

  useEffect(() => {
    setData(expressCheckin);
  }, [expressCheckin]);

  // CONST FUNCTIONS
  const setData = (expressCheckins: any) => {
    // ID COMPANY
    formikProps.setFieldValue('expressCheckingId', expressCheckins.id);

    // DATOS BASICOS
    formikProps.setFieldValue('e_code', expressCheckins.code);
    formikProps.setFieldValue('e_adults', expressCheckins.adults);
    formikProps.setFieldValue('e_minors', expressCheckins.minors);
    formikProps.setFieldValue('e_arrival', expressCheckins.arrivalDate);
    formikProps.setFieldValue('e_departure', expressCheckins.departureDate);
    formikProps.setFieldValue('e_bussines', Boolean(expressCheckins.isBussines));
  };

  return (
    <div>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12 }} sx={{ padding: 2 }}>
          <InputField
            name={e_code.name}
            label={e_code.label}
            variant="outlined"
            autoComplete="off"
            fullWidth
          />
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid size={{ xs: 6 }} sx={{ padding: 2 }}>
          <InputNumeric
            name={e_adults.name}
            label={e_adults.label}
            variant="outlined"
            autoComplete="off"
            fullWidth
          />
        </Grid>
        <Grid size={{ xs: 6 }} sx={{ padding: 2 }}>
          <InputNumeric
            name={e_minors.name}
            label={e_minors.label}
            variant="outlined"
            autoComplete="off"
            fullWidth
          />
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid size={{ xs: 6 }} sx={{ padding: 2 }}>
          <DatePickerDefaultField label={e_arrival.label} name={e_arrival.name} />
        </Grid>
        <Grid size={{ xs: 6 }} sx={{ padding: 2 }}>
          <DatePickerDefaultField label={e_departure.label} name={e_departure.name} />
        </Grid>
      </Grid>

      <Grid size={{ xs: 4 }}>
        <div
          style={{ display: 'flex', flexDirection: 'row', lineHeight: 0, justifyContent: 'end' }}
        >
          <CheckboxField name={e_bussines.name} label={e_bussines.label} />
          <Tooltip title="Si la reserva es para empresas con un unico codigo se pueden registrar la cantidad de personas que se indico en adultos mostrando un unico formulario por persona.">
            <IconButton>
              <HelpOutlineOutlinedIcon color="primary" />
            </IconButton>
          </Tooltip>
        </div>
      </Grid>
    </div>
  );
};
